<template>
    <b-skeleton width="100%" height="250px" v-if="loading" animation="throb"/>

    <div class="main" v-else>
        
        <c-switch class="mx-1 my-2" color="success" variant="pill" :label="true" :dataOn="'UI'" :dataOff="'UI'"
            v-model="showDisabled" />
        <div v-if="showDisabled">
            <b-row class="variable-row">

                <b-col cols="3">Key</b-col>
                <b-col cols="3">Type</b-col>
                <b-col cols="3">Value</b-col>
                <b-col cols="3"></b-col>
            </b-row>
            <div v-for="(variable, index) in variables" :key="index">

                <b-row class="variable-row">

                    <b-col cols="3">
                        <b-form-group :horizontal="true">
                            <input @error="variable.isDuplicate" class="select-input extra-spacing p-2" type="text"
                                name="key" v-model.trim.lazy="variable.key" />
                            <div class="err-msg" v-if="variable.isDuplicate">Key already exists</div>
                        </b-form-group>
                    </b-col>

                    <b-col cols="3">
                        <b-form-group>
                            <select class="extra-spacing select-input" v-model="variable.type"
                                @change="(event) => handleTypeChanges(event, index)">
                                <option value="Array">Array</option>
                                <option value="String">String</option>
                                <option value="Boolean">Boolean</option>
                                <option value="Number">Number</option>
                            </select>
                        </b-form-group>
                    </b-col>

                    <b-col cols="3" v-if="variable.type === 'Array'">
                        <b-form-group>
                            <v-select class="extra-spacing" v-model="variable.value" multiple taggable noDrop />
                        </b-form-group>
                    </b-col>

                    <b-col cols="3" v-else-if="variable.type === 'Number'">
                        <b-form-group>
                            <input type="number" class="select-input extra-spacing p-2" v-model.number="variable.value">
                        </b-form-group>
                    </b-col>

                    <b-col cols="3" v-else-if="variable.type === 'Boolean'">
                        <b-form-group>
                            <c-switch class="extra-spacing" color="primary" variant="pill" :label="false"
                                v-model="variable.value" />
                        </b-form-group>
                    </b-col>

                    <b-col cols="3" v-else-if="!variable.type || variable.type === 'String'">
                        <b-form-group>
                            <input type="text" class="select-input extra-spacing p-2" v-model.trim="variable.value">
                        </b-form-group>
                    </b-col>


                    <b-col cols="3" class="d-flex action-button">
                        <b-button variant="primary" :disabled="!variable.key.length || variable.isDuplicate"
                            v-if="variables.length - 1 === index" @click="addNewVariable">
                            <i class="icon-plus"></i>
                        </b-button>
                        <b-button v-if="variables.length - 1 === index && index !== 0" variant="primary"
                            @click="removeVariable(index)"><i class="icon-minus"></i></b-button>
                    </b-col>
                </b-row>

            </div>

        </div>
        <div v-else class="editor-container">
            <CodeEditor lang="application/json" :controls="false" v-model.lazy="editor" :withButton="false" />
        </div>
        <b-button class="mt-3" variant="primary" @click="save">{{ $t('save') }}</b-button>
    </div>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue';
import CodeEditor from '@/components/form/Editor/Code';
import SelectField from "@/components/form/Select"
import InputField from "@/components/form/Input.vue"
import VSelect from 'vue-select'

export default {
    components: {
        cSwitch,
        CodeEditor,
        InputField,
        SelectField,
        VSelect
    },
    data() {
        return {
            showDisabled: true,
            variables: [{ key: '', value: '', type: 'String', isDuplicate: false }],
            editor: '{}',
            convertedEditorData: {},
            convertedArray: {},
            loading: true
        };
    },
    watch: {
        variables: {
            deep: true,
            handler(newType) {
                let data = JSON.stringify(newType)
                const seenKeys = new Set();

                newType.forEach((variable, index) => {
                    const key = variable.key;
                    if (seenKeys.has(key)) {
                        this.$set(this.variables[index], 'isDuplicate', true);
                    } else {
                        this.$set(this.variables[index], 'isDuplicate', false);
                        seenKeys.add(key);
                    }
                    let parseData = JSON.parse(data)
                    this.editor = JSON.stringify(this.convertArray(parseData), null, 4)

                });

            },
        },
        editor: {
            deep: true,
            handler(newVal) {
                try {
                    let parsedData = JSON.parse(newVal);
                    let flattedOBJ = this.flattenObject(parsedData)
                    let data = Object.entries(flattedOBJ).map(([key, value]) => {
                        return { key, value, "type": this.determineType(value), isDuplicate: false };
                    });

                    this.variables = data
                } catch (error) {
                    console.error('Error parsing JSON:', error);
                }
            },
        },
    },
    methods: {
        handleTypeChanges(event, index) {
            this.$set(this.variables[index], 'value', "");
        },
        addNewVariable() {
            this.variables.push({ key: '', value: '', type: 'String', isDuplicate: false });
        },
        removeVariable(index) {
            if (this.variables.length > 1) {
                this.variables.splice(index, 1);
            }
        },
        convertArray(array) {
            const result = {};

            array.map(item => {
                if (item.isDuplicate) {
                    return
                }
                else if (item.key && item.key.includes('.')) {
                    const keys = item.key.split('.');
                    let current = result;

                    keys.forEach((key, index) => {
                        if (index === keys.length - 1) {
                            current[key] = item.value;
                        } else {
                            if (!current[key]) {
                                current[key] = {};
                            }
                            current = current[key];
                        }
                    });
                } else {
                    result[item.key] = item.value;
                }
            });

            return result;
        },

        flattenObject(obj, prefix = '') {
            let result = {};
            for (const key in obj) {
                if (!obj.hasOwnProperty(key)) {
                    continue;
                }
                const newKey = prefix ? `${prefix}.${key}` : key;
                const value = obj[key];
                if (Array.isArray(value)) {
                    result[newKey] = value;
                } else if (typeof value === 'object' && value !== null) {
                    Object.assign(result, this.flattenObject(value, newKey));
                } else {
                    result[newKey] = value;
                }
            }
            return result;
        },

        determineType(value) {
            const type = typeof value;

            if (type === 'string') {
                return 'String';
            } else if (type === 'number') {
                return 'Number';
            } else if (type === 'boolean') {
                return 'Boolean';
            }

            if (Array.isArray(value)) {
                return 'Array';
            }
            return 'String';
        },

        async save() {
            const popup = this.$loadingPopup()

            try {
                await this.$http.post("/v1/system/platform/env", JSON.parse(this.editor))
            } catch (err) {
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger'
                })

                this.$debugLog(err)
            } finally {
                popup.hide()
            }
        }

    },

    async mounted() {
        try {
            const { data } = await this.$http.get("/v1/system/platform/env")

            this.editor = JSON.stringify(data)

            this.loading = false
        } catch (err) {
            this.$bvToast.toast(this.$t('unexpectedError'), {
                variant: 'danger'
            })
        }
    }
};
</script>


<style scoped>
.main {
    margin: 0px !important;
}

.variable-row {
    max-width: 900px;
    width: 100%;
}

.editor-container {
    max-width: 900px;
    width: 100%;
}

.action-button {
    height: 35px !important;
    margin-top: 20px;
    gap: 10px;
}

.form-group {
    margin: 0;
}

.extra-spacing {
    margin-top: 22px;
}

.select-input {
    width: 100%;
    height: 35px;
    border-radius: 4px;
}

.err-msg {
    font-size: 12px;
    color: red;
    margin-left: 5px;
}
</style>
